import { approveCheckoutSession } from '../../api'

const FRAUD_DECLINE = 'fraud_decline'
const APPROVAL_FAILED_MESSAGE = 'Payment confirmation failed.'

// Never rejects: Stripe is holding the confirm on this call. Resolves to null when the API approved, otherwise
// to the message to show if the confirm then fails because approval was withheld.
export const requestCheckoutSessionApproval = async (
    checkoutSessionId,
    smb = false,
    phone = null
) => {
    try {
        const { data } = await approveCheckoutSession(
            checkoutSessionId,
            smb,
            phone
        )

        return data?.approved === true ? null : APPROVAL_FAILED_MESSAGE
    } catch (error) {
        const { error: message, error_code: errorCode } =
            error?.response?.data || {}

        // A Riskified decline keeps the message a pre-auth decline at submit has always shown.
        return errorCode === FRAUD_DECLINE && message
            ? message
            : APPROVAL_FAILED_MESSAGE
    }
}
